import { isStateOfPip } from "../../../../../lib/script";
import { frontendOptions, medPayMPPolicyStatusOptionsPayerTypes, medPayPIPPolicyStatusOptionsPayerTypes } from "../../../../../lib/systemData";
import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import RadioField from "../../../../common/interactive/RadioField";
import IconBox from "../../../../iconboxes/IconBox";

export default function MedPayDrawerSection({classes, drawerData = {}, goToCaseTabHandler}) {
    const row = drawerData ?? {}
    const mpPipUm = Array.isArray(row.mp_pip_um) ? row.mp_pip_um : []
    const primaryMp = mpPipUm.find((r) => r.is_primary_insurance) || null
    const mpPipUmCount = row.mp_pip_um_count ?? mpPipUm.length

    return <div className={classes.block}>
        <div className={classes.block_header}>
            <h3>MedPay Insurance</h3>
            {mpPipUmCount >= 2 && <div className={classes.totals}>{mpPipUmCount}</div>}
            <button onClick={goToCaseTabHandler.bind(this, 2)}><i className='ti ti ti-arrow-up-right'></i></button>
        </div>
        <div className={classes.block_body}>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Carrier</div>
                <div className={classes.value}>{primaryMp?.insurance_carrier?.name}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>MP Adjuster</div>
                <div className={classes.value}>
                    {primaryMp?.mp_adjuster && <>
                        <div>{primaryMp.mp_adjuster.first_name} {primaryMp.mp_adjuster.last_name}</div>
                        {primaryMp.mp_adjuster.contact_information && primaryMp.mp_adjuster.contact_information.phone && <IconBox type={'phone'} link={primaryMp.mp_adjuster.contact_information.phone} workq={true}>
                            <i className="ti ti-phone"></i>
                        </IconBox>}
                    </>}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>MP Claim Number</div>
                <div className={classes.value}>{primaryMp?.mp_claim_number}</div>
            </div>
            {isStateOfPip(primaryMp?.insurance_state) && 
            <>
            
            <div className={classes.block_body_row}>
                <div className={classes.label}>PIP Status</div>
                <div className={classes.value}>
                    {medPayPIPPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryMp?.pip_status)?.label}
                </div>
            </div>
            <div className={`${classes.block_body_row} ${classes.block_body_row_start}`}>
                <RadioField isDisable={true} fields={frontendOptions()?.medpayPIPStatus} defaultChecked={primaryMp?.has_pip} name={'has_pip'} identifier={{type: 'case_mp_pip_um', field: 'has_pip', type_id: primaryMp?.id, folder: 'mp_pip_um'}}/>
                <CheckboxCell label={'PIP Exhausted'} checked={primaryMp?.pip_exausted} direction={'reverse'} setStyle={'box_small'} trueFlagDanger={true}/>
            </div>
            </>}

            
            <div className={classes.block_body_row}>
                <div className={classes.label}>MP Status</div>
                <div className={classes.value}>
                    {medPayMPPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryMp?.mp_status)?.label}
                </div>
            </div>
            <div className={`${classes.block_body_row} ${classes.block_body_row_start}`}>
                <RadioField isDisable={true} fields={frontendOptions()?.medpayMPStatus} defaultChecked={primaryMp?.has_mp} name={'has_mp'} identifier={{type: 'case_mp_pip_um', field: 'has_mp', type_id: primaryMp?.id, folder: 'mp_pip_um'}}/>
                <CheckboxCell label={'MP Exhausted'} checked={primaryMp?.mp_exausted} direction={'reverse'} setStyle={'box_small'} trueFlagDanger={true}/>
            </div>
            
        </div>
    </div>
}
